import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";

import { ReactComponent as SvgDecoratorBlob3 } from "images/svg-decorator-blob-3.svg";


const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-lg mx-auto py-20 md:py-24`}
`;
const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center`;

const VerticalSpacer = tw.div`mt-10 w-full`

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 max-w-sm`}
`;

const Card = styled.div`
  ${tw`flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left h-full mx-4 px-2 py-8`}
  .imageContainer {
    ${tw`border text-center rounded-full p-5 flex-shrink-0`}
    img {
      ${tw`w-6 h-6`}
    }
  }

  .textContainer {
    ${tw`sm:ml-4 mt-4 sm:mt-2`}
  }

  .title {
    ${tw`mt-4 tracking-wide font-bold text-2xl leading-none`}
  }

  .description {
    ${tw`mt-1 sm:mt-4 font-medium text-secondary-100 leading-loose`}
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;

export default ({ cards = null, heading = "Innovation", subheading = "Innovation", description = "Most of the Indian population uses the internet on various social media platforms as such the application would reach the targeted demographic being internet users." }) => {

  const defaultCards = [
    {
      title: "Independent",
      description: "Existing Solutions are limited to specific social media application while the Viral truth can be used to fact check information found on various platforms therefore it is application independent."
    },
    {
      title: "A one-tap solution",
      description: "Existing Solutions do not appeal to users as they have a sub-optimal interface however the Viral Truth is a one-tap solution which can be used by anyone regardless of their familiarity with technology. The additional voice assistant can also be used."
    },
    {
      title: "Multilingual",
      description: "The Viral truth is multilingual and as such has the ability to understand and respond to queries in different languages whether they be in the form of print/digital media. This feature is also incorporated into the voice assistant."
    },
    {
      title: "Easy to use",
      description: "Existing solutions are dependent on a large community of people and many fact checking organizations for their verification. This makes the process tedious and thus many people do not bother to  check the information they receive. Our solution is able to take information given to it and automatically cross check it against various accepted and accurate sources with one tap making it extremely easy for the user."
    },
    {
      title: "Reliable Sources",
      description: "Existing solution do not provide a means for verifying multiple media types: video, pictures and audio as they are limited to text-based verification - the viral truth can also be applied to print media in addition to digital media."
    },
    {
      title: "Gamification: Making it an habit",
      description: "Many countries and organizations have made attempts to combat misleading information. Even the Goverment of India has approx 60+ initiatives that provides correct information. With gamification, we reward users with coupons and money rewards which will break the barrier of the misinformation spread, making checking facts before forwarding or sharing a habit."
    }
  ];

  if (!cards) cards = defaultCards;

  return (
    <Container id="innovation">
      <ThreeColumnContainer>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        {description && <Description>{description}</Description>}
        <VerticalSpacer />
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="textContainer">
                <span className="title">{card.title}</span>
                <p className="description">
                  {card.description}
                </p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
      <DecoratorBlob />
    </Container>
  );
};
